export default "__VITE_ASSET__CuFavdcQ__"